import { useState, useEffect } from 'react';
import PageHeader from 'components/common/PageHeader';

interface TabbedTablesProps {
    activeTab: string; 
    components: {
        tabName: string, 
        component: React.ReactNode,
    }[]
}

const TabbedTables: React.FC<TabbedTablesProps> = ({activeTab, components}) => {
    const [thisTab, setThisTab] = useState(activeTab); 
    const tabs = components.map(x => x.tabName);  

    useEffect(() => {
        setThisTab(activeTab); 
    }, [activeTab]); 
    
    return (
        <div>
            <div>
                <PageHeader
                    activeTab={thisTab}
                    getTabName={setThisTab}
                    tabs={tabs}
                />
            </div>                
            {components.find(x => x.tabName === thisTab)?.component}
        </div>
    );
}
export default TabbedTables;


